export const MFA_TYPES = {
    SOFTWARE_TOKEN_MFA: 'SOFTWARE_TOKEN_MFA',
    SMS_MFA: 'SMS_MFA'
}

export const MFA_TYPE_LABELS = {
    [MFA_TYPES.SOFTWARE_TOKEN_MFA]: 'Authenticator app',
    [MFA_TYPES.SMS_MFA]: 'SMS'
}

export function getMfaTypeLabel(mfaType) {
    return MFA_TYPE_LABELS[mfaType] || 'Unknown'
}